module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-859.94d84cf1.jpg";